var render = function render(){var _vm=this,_c=_vm._self._c;return (!!_vm.content)?_c('span',{staticClass:"tooltip app-tooltip",class:{ [`text-${_vm.color}`]: true },attrs:{"data-tooltip":_vm.content}},[_c('open-icon',{attrs:{"glyph":_vm.glyph}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }